module.exports = __webpack_public_path__ + "static/media/logo.2b95680a.png";